import { render } from "./DosificacionList.vue?vue&type=template&id=7dfc2e4b&scoped=true"
import script from "./DosificacionList.vue?vue&type=script&lang=js"
export * from "./DosificacionList.vue?vue&type=script&lang=js"

import "./DosificacionList.vue?vue&type=style&index=0&id=7dfc2e4b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfc2e4b"]])

export default __exports__